// SLIDE TO LEFT AS YOU SCROLL EFFECT

$(window).scroll(function(){
    $(".scroll-image-container").css("transform", "translateX(-" + 0 + $(window).scrollTop() / 5 + "px)" );
});


// SMOOTH SCROLL EFFECTS

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      let getUlr = this.href;
      geturl =getUlr.split('#')[1];
      if(geturl == "login" || geturl == "recover"){
        window.location.href = window.location.href+`#${getUlr}`;
      }
      else{
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 60
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
    }
  });

// TOGGLE EFFECTS

$(document).ready(function(){
  $(".info-desc").click(function(){
    $(this).toggleClass("show-desc");
  });
});


// OPEN VIDEO

$(document).ready(function() {
    $('.cta-btn').on('click', function() {
        $("#showVideo").empty();
        var videoUrl = $(this).attr("media");
        $("#showVideo").append("<div class='video-slide-container'><div class='iframe-video-wrapper'><iframe width='560' height='315' src='" + videoUrl + "' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe></div></div>")
    })

});

$("input[type=radio]").click(function () {

	var shampooFFree = "12903448903733:1";
	var shampooCScent = "12903444643893:1";
	var essentialFFree = "31550814453843:1";
	var essentialCScent = "13137224073269:1";
	var serumId = "39323116437587:1?&discount=BUNDLE12OFF";

	if($('#sham-fragrance-free').prop("checked"))
		{ $("#sham-buy-btn").attr("href", "https://helloseen.com/cart/" + shampooFFree );
		 	$(".bundle-1a").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-1b").removeClass("show-price").addClass("hide-price");
		}
		
	if($('#sham-clean-scent').prop("checked"))
		{ $("#sham-buy-btn").attr("href", "https://helloseen.com/cart/" + shampooCScent );
		 	$(".bundle-1b").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-1a").removeClass("show-price").addClass("hide-price");
		}
		
	if($('#ess-fragrance-free').prop("checked"))
		{ $("#ess-buy-btn").attr("href", "https://helloseen.com/cart/" + essentialFFree );
		 	$(".bundle-2a").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-2b").removeClass("show-price").addClass("hide-price");
		}
		
	if($('#ess-clean-scent').prop("checked"))
		{ $("#ess-buy-btn").attr("href", "https://helloseen.com/cart/" + essentialCScent );
		 	$(".bundle-2b").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-2a").removeClass("show-price").addClass("hide-price");
		}
		
	if($('#magic-fragrance-free').prop("checked"))
		{ $("#magic-buy-btn").attr("href", "https://helloseen.com/cart/" + essentialFFree + "," + serumId );
		 	$(".bundle-3a").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-3b").removeClass("show-price").addClass("hide-price");
		}
		
	if($('#magic-clean-scent').prop("checked"))
		{ $("#magic-buy-btn").attr("href", "https://helloseen.com/cart/" + essentialCScent + "," + serumId );
		 	$(".bundle-3b").removeClass("hide-price").addClass("show-price");
		 	$(".bundle-3a").removeClass("show-price").addClass("hide-price");
		}

});